import { getBrandIdByName } from './brands';


const make = (config) => ({
  id: config.id,
  name: config.name,
  nameEn: config.name,
  nameAr: config.nameAr,
  brand: config.brand,
  brandAr: config.brandAr,
  brandId: config.brandId || getBrandIdByName(config.brand) || (config.brand ? config.brand.toLowerCase().replace(/\s+/g, '-') : null),
  category: config.category,
  categoryAr: config.categoryAr,
  size: config.size,
  price: config.price,
  image: config.image,
  imageHover: config.imageHover,
  detailImages: config.detailImages || [config.image, config.imageHover].filter(Boolean),
  description: config.description,
  descriptionAr: config.descriptionAr,
  ingredients: config.ingredients,
  ingredientsAr: config.ingredientsAr,
  benefits: config.benefits,
  benefitsAr: config.benefitsAr,
  section: 'new-diverse',
  hideSizes: true,
  sizes: [],
  inStock: true,
  rating: 4.8,
  reviews: 95 + ((config.id.length * 7) % 60),
});

export const NEW_DIVERSE_PRODUCTS = [
  make({
    id: 'nd-assaf-arrogate-pink-rose',
    name: 'Assaf Arrogate Pink Rose',
    nameAr: 'عساف أروغيت بينك روز',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    price: 2700,
    size: '200ml',
    image: `/image/Perfume brands/Assaf/ASSAF ARROGATE PINK ROSE 2700EGP (1).jpeg`,
    imageHover: `/image/Perfume brands/Assaf/ASSAF ARROGATE PINK ROSE 2700EGP (2).jpeg`,
    description: 'An elegant and feminine floral fragrance by Assaf. Arrogate Pink Rose blends soft rose notes with a warm sensual finish.',
    descriptionAr: 'عطر زهري أنيق وأنثوي من عساف. يجمع أروغيت بينك روز بين نوتات الورد الناعمة ونهاية دافئة وجذابة.',
    ingredients: ['Pink Rose', 'Vanilla', 'White Musk', 'Peony'],
    ingredientsAr: ['الورد الوردي', 'الفانيليا', 'المسك الأبيض', 'الفاوانيا'],
    benefits: ['Long-lasting floral projection', 'Elegant bottle design', 'Perfect for daily wear and events'],
    benefitsAr: ['فوحان زهري يدوم طويلاً', 'تصميم زجاجة أنيق', 'مثالي للاستخدام اليومي والمناسبات'],
  }),
  make({
    id: 'nd-assaf-arrogate-girl',
    name: 'Assaf Arrogate Girl',
    nameAr: 'عساف أروغيت جيرل',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    price: 2700,
    size: '200ml',
    image: `/image/Perfume brands/Assaf/ASSAF Arrogate Girl EDP (200mL) 2700EGP (1).webp`,
    imageHover: `/image/Perfume brands/Assaf/ASSAF Arrogate Girl EDP (200mL) 2700EGP (2).jpg`,
    detailImages: [
      `/image/Perfume brands/Assaf/ASSAF Arrogate Girl EDP (200mL) 2700EGP (1).webp`,
      `/image/Perfume brands/Assaf/ASSAF Arrogate Girl EDP (200mL) 2700EGP (1).jpg`,
      `/image/Perfume brands/Assaf/ASSAF Arrogate Girl EDP (200mL) 2700EGP (2).jpg`,
      `/image/Perfume brands/Assaf/ASSAF Arrogate Girl EDP (200mL) 2700EGP (3).jpg`,
    ],
    description: 'Assaf Arrogate Girl Eau de Parfum is a charming feminine fragrance with delightful floral and sweet undertones, designed for the modern woman.',
    descriptionAr: 'عطر عساف أروغيت جيرل أو دو بارفان هو عطر نسائي ساحر بنفحات زهرية وحلوة لذيذة، مصمم للمرأة العصرية.',
    ingredients: ['Sweet Accords', 'Jasmine', 'Rose', 'Amber'],
    ingredientsAr: ['نوتات حلوة', 'الياسمين', 'الورد', 'العنبر'],
    benefits: ['Charming, sweet scent trail', 'High longevity and silage', 'Delightful youthful presence'],
    benefitsAr: ['هالة عطرية ساحرة وحلوة', 'ثبات وفوحان عالي', 'حضور شبابي مبهج'],
  }),
  make({
    id: 'nd-assaf-lip-stick',
    name: 'Assaf Lip Stick',
    nameAr: 'عساف عطر لب ستيك',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    price: 2700,
    size: '150ml',
    image: `/image/Perfume brands/Assaf/ASSAF Lip Stick - 150ml  عساف عطر لب ستيك للنساء - 150مل2700EGP.png`,
    imageHover: `/image/Perfume brands/Assaf/Lip Stick by Assaf for Women - Eau de Parfum - 150ml 2700 EGP (2).jpeg`,
    detailImages: [
      `/image/Perfume brands/Assaf/ASSAF Lip Stick - 150ml  عساف عطر لب ستيك للنساء - 150مل2700EGP.png`,
      `/image/Perfume brands/Assaf/ASSAF Lip Stick - 150ml  عساف عطر لب ستيك للنساء - 150مل2700EGP.jpg`,
      `/image/Perfume brands/Assaf/ASSAF Lip Stick - 150ml  عساف عطر لب ستيك للنساء - 150مل2700EGP.jpeg`,
      `/image/Perfume brands/Assaf/Lip Stick by Assaf for Women - Eau de Parfum - 150ml 2700 EGP (1).jpeg`,
      `/image/Perfume brands/Assaf/Lip Stick by Assaf for Women - Eau de Parfum - 150ml 2700 EGP (2).jpeg`,
    ],
    description: 'Lip Stick by Assaf for Women is a luxury Eau de Parfum featuring a rich makeup-inspired powdery aroma with exquisite floral accents.',
    descriptionAr: 'عطر لب ستيك من عساف للنساء هو عطر فاخر يتميز برائحة بودرية غنية مستوحاة من عالم المكياج مع نغمات زهرية رائعة.',
    ingredients: ['Powdery Notes', 'Rose', 'Iris', 'Vanilla'],
    ingredientsAr: ['نوتات بودرية', 'الورد', 'السوسن', 'الفانيليا'],
    benefits: ['Unique powdery, luxury aroma', 'Leaves a soft romantic trail', 'Premium 150ml size'],
    benefitsAr: ['رائحة بودرية فاخرة ومميزة', 'يترك أثراً ناعماً ورومانسياً', 'حجم فاخر بسعة 150 مل'],
  }),
  make({
    id: 'nd-assaf-luxury-bukhoor-collection',
    name: 'Assaf Luxury Bukhoor Gift Set',
    nameAr: 'مجموعة بخور عساف الفاخرة',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    price: 4500,
    size: 'Premium Set',
    image: `/image/Perfume brands/Assaf/ASSAF Luxury Bukhoor Collection, Premium Arabian Fragrance Gift Set4500EGP (1).jpg`,
    imageHover: `/image/Perfume brands/Assaf/ASSAF Luxury Bukhoor Collection, Premium Arabian Fragrance Gift Set4500EGP (2).jpg`,
    detailImages: [
      `/image/Perfume brands/Assaf/ASSAF Luxury Bukhoor Collection, Premium Arabian Fragrance Gift Set4500EGP (1).jpg`,
      `/image/Perfume brands/Assaf/ASSAF Luxury Bukhoor Collection, Premium Arabian Fragrance Gift Set4500EGP (2).jpg`,
      `/image/Perfume brands/Assaf/ASSAF Luxury Bukhoor Collection, Premium Arabian Fragrance Gift Set4500EGP (3).jpg`,
      `/image/Perfume brands/Assaf/ASSAF Luxury Bukhoor Collection, Premium Arabian Fragrance Gift Set4500EGP (4).jpg`,
      `/image/Perfume brands/Assaf/ASSAF Luxury Bukhoor Collection, Premium Arabian Fragrance Gift Set4500EGP (5).jpg`
    ],
    description: 'A premium Arabian home fragrance gift set from Assaf, containing an exquisite collection of luxury bukhoor incense blocks.',
    descriptionAr: 'مجموعة هدايا بخور عربية فاخرة من عساف، تحتوي على تشكيلة رائعة من قطع البخور الفاخرة لتعطير المنزل.',
    ingredients: ['Oud Wood', 'Ambergris', 'Taif Rose', 'Sandalwood'],
    ingredientsAr: ['خشب العود', 'العنبر', 'الورد الطائفي', 'خشب الصندل'],
    benefits: ['Fills your home with premium Arabian notes', 'Perfect as a high-end luxury gift', 'Long-lasting and deep projection'],
    benefitsAr: ['يملأ منزلك بنفحات عربية فاخرة', 'مثالي كهدية راقية وقيمة', 'ثبات وفوحان عميق يدوم طويلاً'],
  }),
  make({
    id: 'nd-afnan-9pm-elixir',
    name: 'Afnan 9 PM Elixir',
    nameAr: 'عطر أفنان 9 مساءً إكسير',
    brand: 'Afnan',
    brandAr: 'أفنان',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 2000,
    size: '100ml',
    image: `/image/Perfume brands/Afnan/Afnan 9 Pm Elixir Unisex Extrait De Parfum,100Ml 2000EGP (1).jpg`,
    imageHover: `/image/Perfume brands/Afnan/Afnan 9 Pm Elixir Unisex Extrait De Parfum,100Ml 2000EGP (2).jpg`,
    description: 'Afnan 9 PM Elixir Unisex Extrait De Parfum is a richer, more concentrated version of the iconic 9 PM scent. Bold, seductive and luxurious.',
    descriptionAr: 'عطر أفنان 9 مساءً إكسير للجنسين بتركيز إكستري دو بارفان هو نسخة أكثر ثراءً وتركيزاً من العطر الشهير. جريء وجذاب وفاخر.',
    ingredients: ['Apple', 'Cinnamon', 'Vanilla', 'Amber', 'Patchouli'],
    ingredientsAr: ['التفاح', 'القرفة', 'الفانيليا', 'العنبر', 'الباتشولي'],
    benefits: ['Extrait de Parfum high concentration', 'Unbelievable longevity and sillage', 'Perfect for nighttime and evenings'],
    benefitsAr: ['تركيز عالي إكستري دو بارفان', 'ثبات وفوحان مذهل', 'مثالي للأمسيات والسهرات'],
  }),
  make({
    id: 'nd-assaf-boisee-classic',
    name: 'Boisee - Classic Collection',
    nameAr: 'عطر عساف بواسيه - المجموعة الكلاسيكية',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 3500,
    size: '150ml',
    image: `/image/Perfume brands/Assaf/Boisee From Classic Collection 150ml Extrait De Parfum 3500egp (1).jpg`,
    imageHover: `/image/Perfume brands/Assaf/Boisee From Classic Collection 150ml Extrait De Parfum 3500egp (2).jpg`,
    detailImages: [
      `/image/Perfume brands/Assaf/Boisee From Classic Collection 150ml Extrait De Parfum 3500egp (1).jpg`,
      `/image/Perfume brands/Assaf/Boisee From Classic Collection 150ml Extrait De Parfum 3500egp (2).jpg`,
      `/image/Perfume brands/Assaf/Boisee From Classic Collection 150ml Extrait De Parfum 3500egp (3).jpg`,
      `/image/Perfume brands/Assaf/Boisee From Classic Collection 150ml Extrait De Parfum 3500egp (4).jpg`
    ],
    description: 'Boisee from the Assaf Classic Collection is a 150ml Extrait De Parfum. A woody masterpiece blending dry birchwood and saffron for ultimate prestige.',
    descriptionAr: 'عطر بواسيه من مجموعة عساف الكلاسيكية بحجم 150 مل وتركيز إكستري دو بارفان. تحفة خشبية تمزج بين خشب البتولا الجاف والزعفران لهيبة لا تقاوم.',
    ingredients: ['Woody Notes', 'Birchwood', 'Saffron', 'Cedarwood'],
    ingredientsAr: ['النوتات الخشبية', 'خشب البتولا', 'الزعفران', 'خشب الأرز'],
    benefits: ['High concentration Extrait De Parfum', 'Uniquely dry, elegant woody dry-down', 'Extremely long-lasting performance'],
    benefitsAr: ['تركيز إكستري دو بارفان عالي', 'تجفيف خشبي جاف وأنيق فريد', 'أداء وثبات فائق يدوم طويلاً'],
  }),
  make({
    id: 'nd-assaf-miracle',
    name: 'Miracle Eau De Parfum',
    nameAr: 'عطر عساف ميراكل',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 2300,
    size: '200ml',
    image: `/image/Perfume brands/Assaf/MIRACLE Eau De Parfum 200ml Unisex 2300EGP (1).jpg`,
    imageHover: `/image/Perfume brands/Assaf/MIRACLE Eau De Parfum 200ml Unisex 2300EGP (2).jpg`,
    description: 'Miracle by Assaf is an opulent 200ml Eau de Parfum, creating a beautiful sensory harmony with refreshing top notes and a deep, luxurious base.',
    descriptionAr: 'عطر ميراكل من عساف هو أو دو بارفان بحجم 200 مل، يخلق انسجاماً حسياً رائعاً بنفحات افتتاحية منعشة وقاعدة عميقة فاخرة.',
    ingredients: ['Fresh Accords', 'White Flowers', 'Musk', 'Warm Spices'],
    ingredientsAr: ['نغمات منعشة', 'الزهور البيضاء', 'المسك', 'التوابل الدافئة'],
    benefits: ['Generous 200ml volume', 'Versatile unisex signature scent', 'Radiant silage that gets noticed'],
    benefitsAr: ['حجم سخي 200 مل', 'عطر مميز ومتنوع للجنسين', 'فوحان مشع يجلب الإطراء'],
  }),
  make({
    id: 'nd-assaf-noir-classic',
    name: 'Noir - Classic Collection',
    nameAr: 'عطر عساف نوار - المجموعة الكلاسيكية',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 3500,
    size: '150ml',
    image: `/image/Perfume brands/Assaf/Noir From Classic Collection 150ml Perfum (1) 3500 egp.jpg`,
    imageHover: `/image/Perfume brands/Assaf/Noir From Classic Collection 150ml Perfum (2) 3500 egp.jpg`,
    detailImages: [
      `/image/Perfume brands/Assaf/Noir From Classic Collection 150ml Perfum (1) 3500 egp.jpg`,
      `/image/Perfume brands/Assaf/Noir From Classic Collection 150ml Perfum (2) 3500 egp.jpg`,
      `/image/Perfume brands/Assaf/Noir From Classic Collection 150ml Perfum (3) 3500 egp.jpg`,
      `/image/Perfume brands/Assaf/Noir From Classic Collection 150ml Perfum (4) 3500 egp.jpg`,
      `/image/Perfume brands/Assaf/Noir From Classic Collection 150ml Perfum (5) 3500 egp.jpg`
    ],
    description: 'Noir from the Classic Collection by Assaf is a dark, mysterious composition. A 150ml masterclass in oriental richness and warm amber accords.',
    descriptionAr: 'عطر نوار من المجموعة الكلاسيكية لعساف هو تركيبة غامضة وداكنة. عطر بحجم 150 مل يمثل درساً في الفخامة الشرقية ونغمات العنبر الدافئة.',
    ingredients: ['Amber', 'Oud', 'Sandalwood', 'Spices'],
    ingredientsAr: ['العنبر', 'العود', 'خشب الصندل', 'التوابل الشرقية'],
    benefits: ['Rich, warm oriental profile', 'Extremely luxurious leather/amber feel', 'Excellent silage for winter and evenings'],
    benefitsAr: ['طابع شرقي غني ودافئ', 'إحساس جلدي/عنبري فاخر للغاية', 'فوحان ممتاز للشتاء والأمسيات'],
  }),
  make({
    id: 'nd-assaf-pink-queen',
    name: 'Pink Queen by Assaf',
    nameAr: 'عساف بينك كوين',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    price: 2700,
    size: '200ml',
    image: `/image/Perfume brands/Assaf/Pink Queen for Women by Assaf – Eau de Parfum 200ml 2700EGP (1).jpeg`,
    imageHover: `/image/Perfume brands/Assaf/Pink Queen for Women by Assaf – Eau de Parfum 200ml 2700EGP (2).jpeg`,
    description: 'Pink Queen by Assaf is a luxurious Eau de Parfum designed for women. A radiant, bubbly floral fragrance that celebrates confidence and feminine charm.',
    descriptionAr: 'عطر بينك كوين من عساف هو أو دو بارفان فاخر مصمم للنساء. عطر زهري مشع وحيوي يحتفي بالثقة والجاذبية الأنثوية.',
    ingredients: ['Red Berries', 'Rose', 'Peony', 'Vanilla', 'Musk'],
    ingredientsAr: ['التوق الأحمر', 'الورد', 'الفاوانيا', 'الفانيليا', 'المسك'],
    benefits: ['Bright, joyful fruity opening', 'Immense 200ml value bottle', 'Feminine dry-down that stays on skin'],
    benefitsAr: ['افتتاحية فاكهية مشرقة ومبهجة', 'زجاجة قيمة بحجم 200 مل', 'تجفيف أنثوي ناعم يثبت على البشرة'],
  }),
  make({
    id: 'nd-rasasi-hawas-men',
    name: 'Rasasi Hawas for Men',
    nameAr: 'عطر رصاصي هوس للرجال',
    brand: 'Rasasi',
    brandAr: 'رصاصي',
    category: "Men's Fragrance",
    categoryAr: 'عطر رجالي',
    price: 1900,
    size: '100ml',
    image: `/image/Perfume brands/Rasasi/Rasasi Hawas M Cologne For Men, 100 Ml 1900EGP (1).jpg`,
    imageHover: `/image/Perfume brands/Rasasi/Rasasi Hawas M Cologne For Men, 100 Ml 1900EGP (2).jpg`,
    description: 'Rasasi Hawas for Men blends aquatic notes with warm amber and dynamic woods. A highly fresh, masculine fragrance with an adventurous spirit.',
    descriptionAr: 'يمزج عطر رصاصي هوس للرجال بين النفحات المائية مع العنبر الدافئ والأخشاب الحيوية. عطر رجالي منعش للغاية يعكس روح المغامرة.',
    ingredients: ['Aquatic Accords', 'Apple', 'Cinnamon', 'Bergamot', 'Ambergris'],
    ingredientsAr: ['نغمات بحرية', 'التفاح', 'القرفة', 'البرغموت', 'العنبر الحوت'],
    benefits: ['Iconic fresh aquatic projection', 'Legendary longevity and compliment rate', 'Ideal for hot weather and summer days'],
    benefitsAr: ['فوحان مائي منعش وأيقوني', 'ثبات أسطوري ومعدل إطراء عالٍ جداً', 'مثالي للطقس الحار وأيام الصيف'],
  }),
  make({
    id: 'nd-sweet-edition-set',
    name: 'Sweet Edition Collection',
    nameAr: 'مجموعة سويت إيديشن',
    brand: 'Lithioo Collection',
    brandAr: 'ليثيو كوليكشن',
    category: 'Gift Set',
    categoryAr: 'مجموعة هدايا',
    price: 3700,
    size: '6 x 30ml',
    image: `/image/Perfume brands/Lithioo/Sweet Edition - EDP 6x30ml 3700 EGP.jpg`,
    imageHover: `/image/Perfume brands/Lithioo/Sweet Edition - EDP 6x30ml 3700 EGP.jpg`,
    description: 'A luxury gift set of 6 Eau de Parfum bottles, 30ml each. Sweet Edition offers a curated collection of gourmand, sweet, and comforting scents.',
    descriptionAr: 'طقم هدايا فاخر يحتوي على 6 زجاجات أو دو بارفان، بسعة 30 مل لكل منها. يقدم سويت إيديشن تشكيلة مميزة من الروائح الحلوة والدافئة.',
    ingredients: ['Sugar', 'Vanilla', 'Caramel', 'Sweet Berries'],
    ingredientsAr: ['السكر', 'الفانيليا', 'الكراميل', 'التوت الحلو'],
    benefits: ['6 different premium sweet fragrances', 'Excellent value for fragrance lovers', 'Perfect for travel and gifting'],
    benefitsAr: ['6 عطور حلوة فاخرة ومتنوعة', 'قيمة ممتازة لعشاق العطور', 'مثالية للسفر والإهداء'],
  }),
  make({
    id: 'nd-lador-box',
    name: "L'ador Box Hair Care Set",
    nameAr: 'مجموعة لا دور للعناية بالشعر',
    brand: "L'ador",
    brandAr: 'لادور',
    category: 'Hair Care',
    categoryAr: 'العناية بالشعر',
    price: 3700,
    size: 'Premium Box',
    image: `/image/Perfume brands/L'ador/lador box 3700EGP (1).png`,
    imageHover: `/image/Perfume brands/L'ador/lador box 3700EGP (2).png`,
    detailImages: [
      `/image/Perfume brands/L'ador/lador box 3700EGP (1).png`,
      `/image/Perfume brands/L'ador/lador box 3700EGP (2).png`,
      `/image/Perfume brands/L'ador/lador box 3700EGP (3).png`
    ],
    description: "A luxury complete hair care gift box from L'ador. Nourishes, repairs, and perfumes your hair with delicate professional essence.",
    descriptionAr: 'علبة هدايا فاخرة ومتكاملة للعناية بالشعر من لادور. يغذي ويصلح ويعطر شعرك بخلاصة احترافية ناعمة.',
    ingredients: ['Argan Oil', 'Keratin', 'Silk Protein', 'Delicate Floral Essence'],
    ingredientsAr: ['زيت الأركان', 'الكيراتين', 'بروتين الحرير', 'خلاصة زهرية ناعمة'],
    benefits: ['Professional-grade hair nourishment', 'Perfumes hair with a gorgeous lasting scent', 'Beautiful premium gift box packaging'],
    benefitsAr: ['تغذية احترافية للشعر', 'يعطر الشعر برائحة ساحرة تدوم طويلاً', 'تغليف وتعبئة فاخرة ومثالية للإهداء'],
  }),
  make({
    id: 'nd-assaf-risk-comet',
    name: 'Risk Comet by Assaf',
    nameAr: 'عطر ريسك كوميت من عساف',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 2700,
    size: '200ml',
    image: `/image/Perfume brands/Assaf/ريسك كوميت - عساف 2700 (1).jpg`,
    imageHover: `/image/Perfume brands/Assaf/ريسك كوميت - عساف 2700 (2).jpg`,
    detailImages: [
      `/image/Perfume brands/Assaf/ريسك كوميت - عساف 2700 (1).jpg`,
      `/image/Perfume brands/Assaf/ريسك كوميت - عساف 2700 (2).jpg`,
      `/image/Perfume brands/Assaf/ريسك كوميت - عساف 2700 (3).jpg`
    ],
    description: 'Risk Comet by Assaf is an audacious, stellar fragrance. Blends rare warm spices and amber to create a majestic unisex presence.',
    descriptionAr: 'عطر ريسك كوميت من عساف هو عطر جريء واستثنائي. يمزج بين التوابل الدافئة النادرة والعنبر ليصنع حضوراً مهيباً للجنسين.',
    ingredients: ['Warm Spices', 'Amber', 'Oud', 'Incense'],
    ingredientsAr: ['التوابل الدافئة', 'العنبر', 'العود', 'البخور'],
    benefits: ['Bold, cosmic oriental trail', 'Massive 200ml bottle for longevity', 'Extremely luxurious sillage'],
    benefitsAr: ['أثر شرقي جريء وساحر', 'زجاجة ضخمة 200 مل لتدوم طويلاً', 'فوحان فاخر للغاية'],
  }),
  make({
    id: 'nd-dkhoon-signature-rose-gold',
    name: 'Signature Rose Gold',
    nameAr: 'عطر سيجنتشر روز جولد دخون الإمارات',
    brand: 'Dkhoon Emirates',
    brandAr: 'دخون الإمارات',
    category: 'Unisex Fragrance',
    categoryAr: 'عطر للجنسين',
    price: 1900,
    size: '100ml',
    image: `/image/Perfume brands/Dkhoon Emirates/عطر سيجنتشر روز جولد من دخون الإمارات أو دو بارفان 100 مل 1900EGP (1).jpeg`,
    imageHover: `/image/Perfume brands/Dkhoon Emirates/عطر سيجنتشر روز جولد من دخون الإمارات أو دو بارفان 100 مل 1900EGP (2).jpeg`,
    detailImages: [
      `/image/Perfume brands/Dkhoon Emirates/عطر سيجنتشر روز جولد من دخون الإمارات أو دو بارفان 100 مل 1900EGP (1).jpeg`,
      `/image/Perfume brands/Dkhoon Emirates/عطر سيجنتشر روز جولد من دخون الإمارات أو دو بارفان 100 مل 1900EGP (2).jpeg`,
      `/image/Perfume brands/Dkhoon Emirates/عطر سيجنتشر روز جولد من دخون الإمارات أو دو بارفان 100 مل 1900EGP (3).jpeg`,
      `/image/Perfume brands/Dkhoon Emirates/عطر سيجنتشر روز جولد من دخون الإمارات أو دو بارفان 100 مل 1900EGP (4).jpeg`
    ],
    description: 'Signature Rose Gold by Dkhoon Emirates is a luxurious 100ml Eau de Parfum. A modern signature blending royal rose petals and smooth oriental gold accords.',
    descriptionAr: 'عطر سيجنتشر روز جولد من دخون الإمارات هو أو دو بارفان فاخر بحجم 100 مل. توقيع عصري يمزج بين بتلات الورد الملكي ونغمات الذهب الشرقية الناعمة.',
    ingredients: ['Rose Petals', 'Golden Amber', 'White Musk', 'Patchouli'],
    ingredientsAr: ['بتلات الورد', 'العنبر الذهبي', 'المسك الأبيض', 'الباتشولي'],
    benefits: ['Royal, smooth rose gold projection', 'Premium brand quality from UAE', 'Elegant luxurious presence'],
    benefitsAr: ['فوحان وردي ذهبي ملكي وناعم', 'جودة علامة تجارية فاخرة من الإمارات', 'حضور أنيق وراقي'],
  }),
  make({
    id: 'nd-assaf-miss-grey-intense',
    name: 'Miss Grey Intense',
    nameAr: 'عطر ميس جريس انتنس للنساء',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: "Women's Fragrance",
    categoryAr: 'عطر نسائي',
    price: 1900,
    size: '100ml',
    image: `/image/Perfume brands/Assaf/عطر ميس جريس انتنس للنساء من عساف - او دي بارفان - 100 مل 1900EGP (1).webp`,
    imageHover: `/image/Perfume brands/Assaf/عطر ميس جريس انتنس للنساء من عساف - او دي بارفان - 100 مل 1900EGP (2).webp`,
    description: 'Miss Grey Intense by Assaf is a highly concentrated 100ml Eau de Parfum. A sophisticated feminine scent capturing modern grace and rose-musk elegance.',
    descriptionAr: 'عطر ميس جريس انتنس من عساف للنساء هو أو دو بارفان عالي التركيز بحجم 100 مل. عطر نسائي راقٍ يجسد النعومة العصرية وأناقة الورد والمسك.',
    ingredients: ['Grey Rose', 'White Musk', 'Patchouli', 'Powdery Accords'],
    ingredientsAr: ['الورد الرمادي', 'المسك الأبيض', 'الباتشولي', 'النغمات البودرية'],
    benefits: ['Sophisticated floral-musk signature', 'High longevity for daily and evening wear', 'Refined presentation bottle'],
    benefitsAr: ['توقيع راقٍ من الورد والمسك', 'ثبات عالي يناسب الاستخدام اليومي والمسائي', 'زجاجة عرض أنيقة ومميزة'],
  }),
  make({
    id: 'nd-laverne-blue',
    name: 'Blue Laverne for Men',
    nameAr: 'لافيرن الأزرق للرجال',
    brand: 'Laverne',
    brandAr: 'لافيرن',
    category: "Men's Fragrance",
    categoryAr: 'عطر رجالي',
    price: 2600,
    size: '100ml',
    image: `/image/Perfume brands/Laverne/لافيرن الأزرق للرجال - ماء عطر - 100 مل 2600 (1).jpeg`,
    imageHover: `/image/Perfume brands/Laverne/لافيرن الأزرق للرجال - ماء عطر - 100 مل 2600 (2).jpeg`,
    detailImages: [
      `/image/Perfume brands/Laverne/لافيرن الأزرق للرجال - ماء عطر - 100 مل 2600 (1).jpeg`,
      `/image/Perfume brands/Laverne/لافيرن الأزرق للرجال - ماء عطر - 100 مل 2600 (2).jpeg`,
      `/image/Perfume brands/Laverne/لافيرن الأزرق للرجال - ماء عطر - 100 مل 2600 (1).jpg`,
    ],
    description: 'Blue Laverne for Men is a fresh aromatic fragrance in a 100ml size. A highly energetic blue scent blending citrus with refreshing spicy undertones.',
    descriptionAr: 'عطر لافيرن الأزرق للرجال هو عطر أروما منعش بحجم 100 مل. عطر أزرق مليء بالطاقة يمزج بين الحمضيات ونغمات التوابل المنعشة.',
    ingredients: ['Grapefruit', 'Incense', 'Ginger', 'Mint', 'Woody Notes'],
    ingredientsAr: ['الريب فروت', 'البخور', 'الزنجبيل', 'النعناع', 'النوتات الخشبية'],
    benefits: ['Ultra-fresh energetic masculine projection', 'Compliment magnet for daily wear', 'Extremely versatile all-season scent'],
    benefitsAr: ['فوحان رجالي منعش ومليء بالطاقة', 'عطر جذاب للغاية للاستخدام اليومي', 'متعدد الاستخدامات ويناسب كل الفصول'],
  }),
  make({
    id: 'nd-assaf-wild-colt',
    name: 'Wild Colt by Assaf',
    nameAr: 'عطر وايلد كولت من عساف',
    brand: 'Assaf',
    brandAr: 'عساف',
    category: "Men's Fragrance",
    categoryAr: 'عطر رجالي',
    price: 2600,
    size: '200ml',
    image: `/image/Perfume brands/Assaf/وايلد كولت - عساف 2600 (1).jpg`,
    imageHover: `/image/Perfume brands/Assaf/وايلد كولت - عساف 2600 (2).jpg`,
    detailImages: [
      `/image/Perfume brands/Assaf/وايلد كولت - عساف 2600 (1).jpg`,
      `/image/Perfume brands/Assaf/وايلد كولت - عساف 2600 (2).jpg`,
      `/image/Perfume brands/Assaf/وايلد كولت - عساف 2600 (3).jpg`,
      `/image/Perfume brands/Assaf/وايلد كولت - عساف 2600 (4).jpg`,
      `/image/Perfume brands/Assaf/وايلد كولت - عساف 2600 (5).jpg`
    ],
    description: 'Wild Colt by Assaf is an iconic, fierce masculine fragrance. Featuring a powerful leather and amber composition for a lasting statement.',
    descriptionAr: 'عطر وايلد كولت من عساف هو عطر رجالي أيقوني وجريء. يتميز بتركيبة قوية من الجلد والعنبر ليترك بصمة تدوم طويلاً.',
    ingredients: ['Leather', 'Amber', 'Saffron', 'Oud', 'Vetiver'],
    ingredientsAr: ['الجلد', 'العنبر', 'الزعفران', 'العود', 'الفتيفر'],
    benefits: ['Legendary performance and heavy projection', 'Fierce, commanding leather-amber signature', 'Massive 200ml bottle for ultimate collection value'],
    benefitsAr: ['أداء أسطوري وفوحان قوي جداً', 'توقيع جلدي عنبري حاد ومهيب', 'زجاجة ضخمة 200 مل لقيمة تجميعية قصوى'],
  }),
  make({
      "id": "nd-other-mashaaer-silver",
      "name": "Mashaaer Silver",
      "nameAr": "مشاعر فضي",
      "brand": "Elite Oud",
      "brandAr": "نخبة العود",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 750,
      "size": "100ml",
      "image": "/image/Perfume brands/Other/مشاعر فضي 750 (1).jpg",
      "imageHover": "/image/Perfume brands/Other/مشاعر فضي 750 (2).jpg",
      "detailImages": [
          "/image/Perfume brands/Other/مشاعر فضي 750 (1).jpg",
          "/image/Perfume brands/Other/مشاعر فضي 750 (2).jpg"
      ],
      "description": "Mashaaer Silver is a captivating oriental fragrance blending refreshing top notes with a luxurious amber and musk base.",
      "descriptionAr": "عطر مشاعر فضي عطر شرقي ساحر يجمع بين الإشراق والانتعاش مع قاعدة فاخرة من العنبر والمسك.",
      "ingredients": [
          "Bergamot",
          "Geranium",
          "White Musk",
          "Amber"
      ],
      "ingredientsAr": [
          "البرغموت",
          "إبرة الراعي",
          "المسك الأبيض",
          "العنبر"
      ],
      "benefits": [
          "Gentle yet captivating oriental trail",
          "Affordable luxury for every day",
          "Ideal for both men and women"
      ],
      "benefitsAr": [
          "أثر شرقي هادئ وساحر",
          "فخامة يومية بسعر مميز",
          "مثالي للرجال والنساء"
      ]
  }),
  make({
      "id": "nd-lattafa-oud-mood",
      "name": "Lattafa Oud Mood",
      "nameAr": "عطر لطافة عود مود",
      "brand": "Lattafa",
      "brandAr": "لطافة",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 1200,
      "size": "100ml",
      "image": "/image/Perfume brands/Lattafa/عطر لطافة عود مود للجنسين - او دي بارفان - 100 مل 1200  (1).jpeg",
      "imageHover": "/image/Perfume brands/Lattafa/عطر لطافة عود مود للجنسين - او دي بارفان - 100 مل 1200  (2).jpg",
      "detailImages": [
          "/image/Perfume brands/Lattafa/عطر لطافة عود مود للجنسين - او دي بارفان - 100 مل 1200  (1).jpeg",
          "/image/Perfume brands/Lattafa/عطر لطافة عود مود للجنسين - او دي بارفان - 100 مل 1200  (2).jpg",
          "/image/Perfume brands/Lattafa/عطر لطافة عود مود للجنسين - او دي بارفان - 100 مل 1200  (3).jpg"
      ],
      "description": "Lattafa Oud Mood Eau de Parfum is an alluring oriental sweet oud fragrance with warm spices, caramel, and amber.",
      "descriptionAr": "عطر لطافة عود مود للجنسين ماء عطر شرقي دافئ يجمع بين حلاوة الكراميل والعنبر مع فخامة العود والتوابل.",
      "ingredients": [
          "Oud",
          "Caramel",
          "Floral Notes",
          "Amber",
          "Resins"
      ],
      "ingredientsAr": [
          "العود",
          "الكراميل",
          "النوتات الزهرية",
          "العنبر",
          "الراتنجات"
      ],
      "benefits": [
          "Warm sweet-oud projection",
          "Excellent longevity",
          "Rich comforting autumn/winter scent"
      ],
      "benefitsAr": [
          "فوحان عود حلو ودافئ",
          "ثبات ممتاز يدوم طويلاً",
          "عطر شتوي مريح وفاخر"
      ]
  }),
  make({
      "id": "nd-amarah-rehal-forest",
      "name": "Rehal Forest AMARAH by LE BONHEUR",
      "nameAr": "عطر رحال فورست أمارة من لو بونور",
      "brand": "Amarah",
      "brandAr": "أمارة",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 2300,
      "size": "100ml",
      "image": "/image/Perfume brands/Amarah/Rehal Forest AMARAH by LE BONHEUR 100ml 2300 (1).png",
      "imageHover": "/image/Perfume brands/Amarah/Rehal Forest AMARAH by LE BONHEUR 100ml 2300 (2).png",
      "detailImages": [
          "/image/Perfume brands/Amarah/Rehal Forest AMARAH by LE BONHEUR 100ml 2300 (1).png",
          "/image/Perfume brands/Amarah/Rehal Forest AMARAH by LE BONHEUR 100ml 2300 (2).png"
      ],
      "description": "Rehal Forest AMARAH by LE BONHEUR is a rich woody aromatic perfume capturing the spirit of untouched nature and exotic forests.",
      "descriptionAr": "عطر رحال فورست أمارة من لو بونور هو عطر خشبي أروما فاخر يجسد سحر الطبيعة العذراء وغموض الغابات الاستوائية.",
      "ingredients": [
          "Cedarwood",
          "Cypress",
          "Earthy Notes",
          "Musk",
          "Vetiver"
      ],
      "ingredientsAr": [
          "خشب الأرز",
          "السرو",
          "النوتات الترابية",
          "المسك",
          "الفتيفر"
      ],
      "benefits": [
          "Invigorating forest-fresh aura",
          "Distinctive signature woody aroma",
          "High concentration and projection"
      ],
      "benefitsAr": [
          "هالة عطرية منعشة كالغابات الطبيعية",
          "توقيع خشبي مميز وفريد",
          "تركيز عالٍ وفوحان ملموس"
      ]
  }),
  make({
      "id": "nd-armaf-club-de-nuit",
      "name": "Club De Nuit Intense Man",
      "nameAr": "كلوب دي نوي إنتنس للرجال",
      "brand": "Armaf",
      "brandAr": "أرماف",
      "category": "Men's Fragrance",
      "categoryAr": "عطر رجالي",
      "price": 2300,
      "size": "105ml",
      "image": "/image/Perfume brands/Armaf/CLUB DE NUIT INTENSE MAN 105 ML 2300 (1).jpeg",
      "imageHover": "/image/Perfume brands/Armaf/CLUB DE NUIT INTENSE MAN 105 ML 2300 (2).jpeg",
      "detailImages": [
          "/image/Perfume brands/Armaf/CLUB DE NUIT INTENSE MAN 105 ML 2300 (1).jpeg",
          "/image/Perfume brands/Armaf/CLUB DE NUIT INTENSE MAN 105 ML 2300 (2).jpeg"
      ],
      "description": "Armaf Club De Nuit Intense Man is a worldwide sensation featuring bold smoky pineapple, birch, and blackcurrant notes.",
      "descriptionAr": "عطر كلوب دي نوي إنتنس للرجال من أرماف، أيقونة عالمية بتركيبة مدخنة جذابة تجمع الأناناس والبتولا والكشمش الأسود.",
      "ingredients": [
          "Lemon",
          "Pineapple",
          "Birch",
          "Blackcurrant",
          "Patchouli",
          "Musk"
      ],
      "ingredientsAr": [
          "الليمون",
          "الأناناس",
          "البتولا",
          "الكشمش الأسود",
          "البتشولي",
          "المسك"
      ],
      "benefits": [
          "Legendary compliment magnet",
          "Beast mode projection and longevity",
          "Versatile signature for any occasion"
      ],
      "benefitsAr": [
          "جاذبية أسطورية تلفت الأنظار",
          "فوحان وثبات فائق القوة",
          "عطر توقيع شخصي يناسب جميع المناسبات"
      ]
  }),
  make({
      "id": "nd-lithioo-silk-musk-uae",
      "name": "Silk Musk Eau De Parfum (UAE)",
      "nameAr": "عطر سيلك مسك أو دي بارفان (الإمارات)",
      "brand": "Lithioo",
      "brandAr": "ليثيو",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 1500,
      "size": "100ml",
      "image": "/image/Perfume brands/Lithioo/Silk Musk Eau De Parfum 100ml Longlasting Fragrance for Unisex (UAE) 1500 (1).webp",
      "imageHover": "/image/Perfume brands/Lithioo/Silk Musk Eau De Parfum 100ml Longlasting Fragrance for Unisex (UAE) 1500 (2).webp",
      "detailImages": [
          "/image/Perfume brands/Lithioo/Silk Musk Eau De Parfum 100ml Longlasting Fragrance for Unisex (UAE) 1500 (1).webp",
          "/image/Perfume brands/Lithioo/Silk Musk Eau De Parfum 100ml Longlasting Fragrance for Unisex (UAE) 1500 (2).webp",
          "/image/Perfume brands/Lithioo/Silk Musk Eau De Parfum 100ml Longlasting Fragrance for Unisex (UAE) 1500 (3).webp"
      ],
      "description": "Silk Musk Eau De Parfum 100ml is a velvety smooth, pure white musk fragrance crafted in the UAE for ultimate softness and longevity.",
      "descriptionAr": "عطر سيلك مسك أو دي بارفان 100 مل مسك ناعم كالحرير مصمم في الإمارات بنقاء استثنائي وثبات ناعم يدوم طوال اليوم.",
      "ingredients": [
          "Silk Musk",
          "Lily of the Valley",
          "Powdery Notes",
          "White Amber"
      ],
      "ingredientsAr": [
          "مسك الحرير",
          "زنبق الوادي",
          "النوتات البودرية",
          "العنبر الأبيض"
      ],
      "benefits": [
          "Pure silky clean scent",
          "Long-lasting soft radiance",
          "Delicate and skin-friendly"
      ],
      "benefitsAr": [
          "رائحة نظافة حريرية نقية",
          "إشراقة ناعمة تدوم طويلاً",
          "لطيف ومريح جداً على البشرة"
      ]
  }),
  make({
      "id": "nd-french-avenue-marmara",
      "name": "Extrait de Parfum Marmara",
      "nameAr": "عطر مرمرة إكستري دي بارفان",
      "brand": "French Avenue",
      "brandAr": "فرنش أفينيو",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 2500,
      "size": "100ml",
      "image": "/image/Perfume brands/French Avenue/Extrait de parfum Marmara 100 ml - French Avenue 2500ج (1).webp",
      "imageHover": "/image/Perfume brands/French Avenue/Extrait de parfum Marmara 100 ml - French Avenue 2500ج (2).jpeg",
      "detailImages": [
          "/image/Perfume brands/French Avenue/Extrait de parfum Marmara 100 ml - French Avenue 2500ج (1).webp",
          "/image/Perfume brands/French Avenue/Extrait de parfum Marmara 100 ml - French Avenue 2500ج (2).jpeg"
      ],
      "description": "Extrait de parfum Marmara by French Avenue is a high-concentration niche creation combining Mediterranean marine freshness with deep woody resins.",
      "descriptionAr": "عطر مرمرة إكستري دي بارفان من فرنش أفينيو بتركيز نيش فائق، يمزج انتعاش البحر الأبيض المتوسط مع فخامة الأخشاب والراتنجات.",
      "ingredients": [
          "Marine Notes",
          "Citrus Peel",
          "Cedar",
          "Ambergris",
          "Rare Spices"
      ],
      "ingredientsAr": [
          "النوتات البحرية",
          "قشور الحمضيات",
          "خشب الأرز",
          "العنبر الرمادي",
          "التوابل النادرة"
      ],
      "benefits": [
          "Niche quality Extrait de Parfum concentration",
          "Crisp fresh yet opulent deep base",
          "Spectacular endurance"
      ],
      "benefitsAr": [
          "تركيز إكستري دي بارفان بجودة النيش",
          "انتعاش نقي مع قاعدة فاخرة عميقة",
          "ثبات استثنائي يدوم لأيام"
      ]
  }),
  make({
      "id": "nd-arabiyat-aqriz",
      "name": "Aqriz by Arabiyat Prestige",
      "nameAr": "عطر أقريز من عربيات برستيج",
      "brand": "Arabiyat Prestige",
      "brandAr": "عربيات برستيج",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 2300,
      "size": "100ml",
      "image": "/image/Perfume brands/arabiyat prestige/aqriz 100ml 2300 (1).jpg",
      "imageHover": "/image/Perfume brands/arabiyat prestige/aqriz 100ml 2300 (2).jpg",
      "detailImages": [
          "/image/Perfume brands/arabiyat prestige/aqriz 100ml 2300 (1).jpg",
          "/image/Perfume brands/arabiyat prestige/aqriz 100ml 2300 (2).jpg"
      ],
      "description": "Aqriz by Arabiyat Prestige presents an opulent oriental experience rich in amber, rare spices, and precious wood.",
      "descriptionAr": "عطر أقريز من عربيات برستيج يقدم تجربة شرقية فاخرة غنية بالعنبر والتوابل النادرة والأخشاب الكريمة.",
      "ingredients": [
          "Saffron",
          "Nutmeg",
          "Precious Woods",
          "Amber",
          "Musk"
      ],
      "ingredientsAr": [
          "الزعفران",
          "جوزة الطيب",
          "الأخشاب الثمينة",
          "العنبر",
          "المسك"
      ],
      "benefits": [
          "Prestigious oriental projection",
          "Sophisticated bottle presentation",
          "Balanced spicy-sweet harmony"
      ],
      "benefitsAr": [
          "فوحان شرقي فاخر ومهيب",
          "تصميم زجاجة فائق الأناقة",
          "تناغم متوازن بين الدفء والتوابل"
      ]
  }),
  make({
      "id": "nd-arabiyat-kohl",
      "name": "Kohl by Arabiyat Prestige",
      "nameAr": "عطر كحل من عربيات برستيج",
      "brand": "Arabiyat Prestige",
      "brandAr": "عربيات برستيج",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 2200,
      "size": "100ml",
      "image": "/image/Perfume brands/arabiyat prestige/kohl 100ml 2200 (1).jpg",
      "imageHover": "/image/Perfume brands/arabiyat prestige/kohl 100ml 2200 (2).jpg",
      "detailImages": [
          "/image/Perfume brands/arabiyat prestige/kohl 100ml 2200 (1).jpg",
          "/image/Perfume brands/arabiyat prestige/kohl 100ml 2200 (2).jpg"
      ],
      "description": "Kohl by Arabiyat Prestige is an intense, enigmatic perfume with dark smoky accords, incense, and velvet florals.",
      "descriptionAr": "عطر كحل من عربيات برستيج عطر غامض ومكثف بنغمات مدخنة آسرة من البخور ونفحات زهرية مخملية.",
      "ingredients": [
          "Incense",
          "Dark Rose",
          "Smoky Woods",
          "Oud Accord",
          "Leather"
      ],
      "ingredientsAr": [
          "البخور",
          "الورد الداكن",
          "الأخشاب المدخنة",
          "أكورد العود",
          "الجلد"
      ],
      "benefits": [
          "Deep enigmatic personality",
          "Long-lasting smoky-sweet sillage",
          "Perfect for formal evening wear"
      ],
      "benefitsAr": [
          "شخصية عطرية عميقة وساحرة",
          "فوحان دخاني حلو يدوم طويلاً",
          "مثالي للأمسيات والمناسبات الرسمية"
      ]
  }),
  make({
      "id": "nd-arabiyat-raees-aurum",
      "name": "Raees Aurum by Arabiyat Prestige",
      "nameAr": "عطر رئيس أوروم من عربيات برستيج",
      "brand": "Arabiyat Prestige",
      "brandAr": "عربيات برستيج",
      "category": "Men's Fragrance",
      "categoryAr": "عطر رجالي",
      "price": 2300,
      "size": "180ml",
      "image": "/image/Perfume brands/arabiyat prestige/RAEES-AURUM_ 180مل  2300ج (1).jpg",
      "imageHover": "/image/Perfume brands/arabiyat prestige/RAEES-AURUM_ 180مل  2300ج (2).jpg",
      "detailImages": [
          "/image/Perfume brands/arabiyat prestige/RAEES-AURUM_ 180مل  2300ج (1).jpg",
          "/image/Perfume brands/arabiyat prestige/RAEES-AURUM_ 180مل  2300ج (2).jpg"
      ],
      "description": "Raees Aurum in a generous 180ml bottle delivers a regal golden aura with luminous citrus, ambergris, and refined leather.",
      "descriptionAr": "عطر رئيس أوروم بحجم 180 مل الكبير يمنحك هالة ذهبية ملكية من الحمضيات المضيئة والعنبر والجلد الراقي.",
      "ingredients": [
          "Bergamot",
          "Cardamom",
          "Ambergris",
          "Cedarwood",
          "Leather"
      ],
      "ingredientsAr": [
          "البرغموت",
          "الهيل",
          "عنبر الحوت",
          "خشب الأرز",
          "الجلد"
      ],
      "benefits": [
          "Massive 180ml luxury edition",
          "Royal masculine aura",
          "Outstanding value and sillage"
      ],
      "benefitsAr": [
          "إصدار فاخر بحجم 180 مل ضخم",
          "هالة ملكية رجالية لا تُنسى",
          "قيمة استثنائية وفوحان فائق"
      ]
  }),
  make({
      "id": "nd-arabiyat-revolt",
      "name": "Revolt Uncaged by Arabiyat Prestige",
      "nameAr": "عطر ريفولت أنكيجد من عربيات برستيج",
      "brand": "Arabiyat Prestige",
      "brandAr": "عربيات برستيج",
      "category": "Unisex Fragrance",
      "categoryAr": "عطر للجنسين",
      "price": 2300,
      "size": "100ml",
      "image": "/image/Perfume brands/arabiyat prestige/Revolt uncaged 100ml 2300 (1).jpg",
      "imageHover": "/image/Perfume brands/arabiyat prestige/Revolt uncaged 100ml 2300 (2).jpg",
      "detailImages": [
          "/image/Perfume brands/arabiyat prestige/Revolt uncaged 100ml 2300 (1).jpg",
          "/image/Perfume brands/arabiyat prestige/Revolt uncaged 100ml 2300 (2).jpg"
      ],
      "description": "Revolt Uncaged is a rebellious and modern masterpiece boasting vibrant spices, aromatic lavender, and dark vetiver.",
      "descriptionAr": "عطر ريفولت أنكيجد تحفة عطرية جريئة وعصرية تفيض بالتوابل الحيوية واللافندر العطري والفتيفر الداكن.",
      "ingredients": [
          "Black Pepper",
          "Lavender",
          "Tonka Bean",
          "Dark Vetiver",
          "Amber"
      ],
      "ingredientsAr": [
          "الفلفل الأسود",
          "اللافندر",
          "حبوب التونكا",
          "الفتيفر الداكن",
          "العنبر"
      ],
      "benefits": [
          "Bold modern rebellious projection",
          "Energizing spicy-fresh contrast",
          "Remarkable staying power"
      ],
      "benefitsAr": [
          "فوحان جريء وعصري يلفت الانتباه",
          "تباين حيوي ومنعش بين التوابل والأخشاب",
          "ثبات ممتاز طوال اليوم"
      ]
  }),
];
